<template>
  <div v-if="!ready" v-loading="!ready" element-loading-text="拼命加载中" class="page-loading"></div>
  <div v-else>
    <div class="pull-right" style="position: relative; z-index: 1;">
      <el-input placeholder="搜索成果" class="max-width-200 w-a"
                suffix-icon="el-icon-search" v-model="search"></el-input>
      <el-button v-if="is_check" type="success" size="small" class="m-t-5"
                 @click="batchSubmit()" :loading="submit_loading>0">
        批量通过
      </el-button>
      <el-button v-else type="success" size="small" class="m-t-5"
                 @click="exportData()" :loading="export_loading>0">
        导出全部记录
      </el-button>
      <el-button type="danger" size="small" class="m-t-5"
                 @click="batchDelete()" :loading="submit_loading>0">
        批量删除
      </el-button>
    </div>
    <el-tabs v-model="active_index">
      <el-tab-pane v-for="(type, index) in types" :key="type.id" :name="index+''"
                   :label="type.name+' ('+type.achievements.length+')'">
      </el-tab-pane>
    </el-tabs>
    <el-table :data="page" border ref="table">
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column label="教师" prop="teacher_uid">
        <template slot-scope="scope">
          <span v-html="$highlight(scope.row.teacher_name, scope.row.$$pinyin.teacher_name)"></span>
        </template>
      </el-table-column>
      <el-table-column v-for="col in active_type.form" :key="col.prop" :label="col.name"
                       :prop="col.prop" v-if="col.type !== 'file'">
        <template slot-scope="scope">
          <span v-if="col.type==='select'&&col.multiple">{{scope.row[col.prop].join('、')}}</span>
          <span v-else-if="col.filterable"
                v-html="$highlight(scope.row[col.prop], scope.row.$$pinyin[col.prop])"></span>
          <span v-else>{{scope.row[col.prop]}}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="180" align="center" class-name="no-padding">
        <template slot-scope="scope">
          <template v-if="is_check">
            <el-button type="warning" size="mini" @click="batchSubmit([scope.row])"
                       :disabled="submit_loading>0">通过
            </el-button>
            <router-link v-if="$location.admin_achievement_check.auth()"
                         :to="$location.admin_achievement_check({achievement_uid:scope.row.uid})"
                         class="el-button el-button--primary el-button--mini">查看/不通过
            </router-link>
          </template>
          <router-link v-else-if="$location.admin_achievement_view.auth()"
                       :to="$location.admin_achievement_view({achievement_uid:scope.row.uid})"
                       class="el-button el-button--primary el-button--mini">查看
          </router-link>
          <el-button type="danger" size="mini" @click="batchDelete([scope.row])"
                     :disabled="submit_loading>0">删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination v-if="filtered.length>pageInfo.page" :total="filtered.length"
                   :page-size="pageInfo.page" :current-page.sync="pageInfo.current"
                   class="text-center m-t-10" layout="prev, pager, next"></el-pagination>
  </div>
</template>

<script>
import groupBy from 'lodash/groupBy'
import keyBy from 'lodash/keyBy'

import * as Achievement from 'api/achievement'
import page from 'utils/page'

export default {
  data () {
    return {
      ready: false,
      list: [],
      types: null,
      submit_loading: 0,
      export_loading: 0,
      active_index: '0',
      search: '',
      pageInfo: {page: 10, current: 1},
    }
  },
  computed: {
    is_check () {
      return this.$route.name === this.$location.admin_achievement_check_list().name
    },
    active_type () {
      return this.types[this.active_index]
    },
    active_list () {
      return this.active_type.achievements
    },
    filtered () {
      return this.$search(this.active_list, this.search, this.active_type.searchFields)
    },
    page () {
      return page(this.filtered, this.pageInfo)
    },
  },
  methods: {
    async init () {
      this.ready = false
      this.$guard()(async () => {
        let [list, types, status] = await Promise.all([
          this.loadList(),
          Achievement.types(),
          Achievement.status(),
        ])
        types.forEach(type => {
          type.searchFields = type.form.filter(item => item.filterable).map(item => item.prop)
          type.searchFields.unshift('teacher_name')
          type.achievements = []
        })
        this.status_map = keyBy(status, 'id')
        this.types = types
        this.setUp(list)
        this.active_index = '0'
        if (this.$query.type) {
          let idx = types.findIndex(type => type.id === +this.$query.type)
          if (idx > -1) this.active_index = idx + ''
        }
        this.doInit()
        this.ready = true
      })
    },
    doInit () {
      this.pageInfo.current = 1
      this.$updateQuery({type: this.types[this.active_index].id})
    },
    async reload () {
      let list = await (this.is_check ? Achievement.check_list() : Achievement.admin_list())
      this.setUp(list)
    },
    loadList () {
      return this.is_check ? Achievement.check_list() : Achievement.admin_list()
    },
    setUp (list) {
      list.forEach(item => item.$$status_title = this.status_map[item.status].name)
      let group = groupBy(list, 'type')
      this.types.forEach(type => {
        type.achievements = group[type.id] || []
      })
    },
    batchSubmit (achievements) {
      if (this.submit_loading) return
      achievements = achievements || this.$refs.table.selection
      if (!achievements.length) {
        this.$message('请选择待通过的成果')
        return
      }
      this.$guard(this, 'submit_loading')(async () => {
        let data = achievements.map(achievement => ({uid: achievement.uid, check: true}))
        await Achievement.check({data})
        // reload all list
        await this.reload()
        this.$message.success('提交成功')
      })
    },
    async batchDelete (achievements) {
      if (this.submit_loading) return
      achievements = achievements || this.$refs.table.selection
      if (!achievements.length) return this.$message('请选择待删除的成果')
      if (!await this.$dangerConfirm('您确定要删除成果吗？')) return
      this.$guard(this, 'submit_loading')(async () => {
        let data = achievements.map(achievement => ({uid: achievement.uid}))
        await Achievement.remove({data})
        // reload all list
        await this.reload()
        this.$message.success('删除成功')
      })
    },
    exportData () {
      let type = this.types[this.active_index]
      this.$guard(this, 'export_loading')(async () => {
        window.location.href = await Achievement.export_data({type: type.id})
      })
    },
  },
  created () {
    this.init()
  },
  watch: {
    $route () {
      if (!this.$dontReload) this.init()
    },
    active_index: 'doInit',
  },
}
</script>

<style scoped lang="scss"></style>



// WEBPACK FOOTER //
// src/components/achievement/AchievementAdminList.vue